import { Typography } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './BoyrunText.module.scss';

interface BoyrunTextProps {
    children: React.ReactNode;
    fontSize?: 'x3large';
}

const BoyrunText = ({ children, fontSize = 'x3large' }: BoyrunTextProps) => {
    useStyles(stylesheet);

    return (
        <Typography className={styles.boyrunText} fontSize={fontSize} as="p" margin={0}>
            {children}
        </Typography>
    );
};

export default BoyrunText;
